import { render } from "./CurrenciesPage.vue?vue&type=template&id=df8d44d8"
import script from "./CurrenciesPage.vue?vue&type=script&lang=js"
export * from "./CurrenciesPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__